export const GET_CUSTOMERS = '/api/customers';
export const GET_CUSTOMER = (customer) => `/api/customers/${customer}`;
export const POST_CUSTOMER = '/api/customers';
export const UPDATE_CUSTOMER = (customer) => `/api/customers/${customer}`;
export const DELETE_CUSTOMER = (customer) => `/api/customers/${customer}`;

export const GET_DRIVERS = '/api/drivers';
export const GET_DRIVER = (driver) => `/api/drivers/${driver}`;
export const POST_DRIVER = '/api/drivers';
export const UPDATE_DRIVER = (driver) => `/api/drivers/${driver}`;
export const DELETE_DRIVER = (driver) => `/api/drivers/${driver}`;

export const GET_SITES = '/api/sites';
export const GET_SITE = (site) => `/api/sites/${site}`;
export const POST_SITE = '/api/sites';
export const UPDATE_SITE = (site) => `/api/sites/${site}`;
export const DELETE_SITE = (site) => `/api/sites/${site}`;

export const GET_TOURS = '/api/tours';
export const GET_TOUR = (tour) => `/api/tours/${tour}`;
export const POST_TOUR = '/api/tours';
export const UPDATE_TOUR = (tour) => `/api/tours/${tour}`;
export const DELETE_TOUR = (tour) => `/api/tours/${tour}`;
export const CANCEL_PACKAGE = (tour, step = null) => `/api/tours/${tour}/cancel_product`;
export const CANCEL_TOUR = (tour) => `/api/tours/${tour}/cancel_tour`;

export const GET_TOUR_MODELS = '/api/tour_models';
export const GET_TOUR_MODEL = (tour_model) => `/api/tour_models/${tour_model}`;
export const POST_TOUR_MODEL = '/api/tour_models';
export const UPDATE_TOUR_MODEL = (tour_model) => `/api/tour_models/${tour_model}`;
export const DELETE_TOUR_MODEL = (tour_model) => `/api/tour_models/${tour_model}`;
export const UPDATE_TOUR_MODEL_CUSTOMERS = (tour_model) => `/api/tour_models/${tour_model}/customers`;

export const POST_MESSAGE = '/api/messages';
export const GET_DRIVER_MESSAGES = '/api/drivers/messages';

export const GET_TOUR_TYPES = '/api/tour_types';
export const GET_TOUR_TYPE = (tour_type) => `/api/tour_types/${tour_type}`;
export const POST_TOUR_TYPE = '/api/tour_types';
export const UPDATE_TOUR_TYPE = (tour_type) => `/api/tour_types/${tour_type}`;
export const DELETE_TOUR_TYPE = (tour_type) => `/api/tour_types/${tour_type}`;

export const GET_USERS = '/api/users';
export const GET_USER = (user) => `/api/users/${user}`;
export const POST_USER = '/api/users';
export const UPDATE_USER = (user) => `/api/users/${user}`;
export const DELETE_USER = (user) => `/api/users/${user}`;
export const UPDATE_USER_PASSWORD = (user) => `/api/users/${user}/password`;

export const GET_LOADING_STATES = '/api/loading_states';
export const GET_LOADING_STATE = (loading_state) => `/api/loading_states/${loading_state}`;
export const POST_LOADING_STATE = '/api/loading_states';
export const UPDATE_LOADING_STATE = (loading_state) => `/api/loading_states/${loading_state}`;
export const DELETE_LOADING_STATE = (loading_state) => `/api/loading_states/${loading_state}`;

export const GET_TOUR_STATES = '/api/tour_states';
export const GET_TOUR_STATE = (tour_state) => `/api/tour_states/${tour_state}`;
export const POST_TOUR_STATE = '/api/tour_states';
export const UPDATE_TOUR_STATE = (tour_state) => `/api/tour_states/${tour_state}`;
export const DELETE_TOUR_STATE = (tour_state) => `/api/tour_states/${tour_state}`;

export const GET_TOUR_LOADINGS = (tour) => `/api/tours/${tour}/loadings`

export const GET_SITE_MODEL_NUMBERS = (site) => `/api/sites/${site}/model_numbers`
export const CREATE_SITE_MODEL_NUMBERS = (site) => `/api/sites/${site}/model_numbers`
export const DELETE_SITE_MODEL_NUMBERS = (site, model) => `/api/sites/${site}/model_numbers/${model}`

export const GET_TOUR_TYPE_SITES = (tour_type) => `/api/tour_types/${tour_type}/sites`
export const GET_TOUR_TYPE_SITE_MODEL_NUMBERS = (tour_type, site) => `/api/tour_types/${tour_type}/sites/${site}/model_numbers`

export const GET_CONFIGS = () => `/api/configs`;
export const POST_CONFIG = () => `/api/configs`;

export const SEND_RESET_LINK = '/api/auth/reset_link'
export const RESET_PASSWORD = '/api/auth/reset_password'

export const GET_PAYMENT_MODES = '/api/payment_modes';
